<template>
  <header>
    <div class="header-top">
      <h1 class="logo__text">
        <span>EXA</span>
        <span class="logo__top logo__subText">WEB-END</span>
        <span class="logo__bottom logo__subText">SOLUTIONS</span>
      </h1>
<!--      <div v-on:click="toggleNavigation()" :class="{active: isNavigationOpen}" class="hamburger"></div>-->
    </div>


<!--    <div :class="{active: isNavigationOpen}" class="navigation">-->
<!--      <pageFooter-->
<!--        v-bind:langIsGerman="langIsGerman"-->
<!--        v-on:closeNav="toggleNavigation(false)"-->
<!--        v-bind:showHome="true">-->
<!--      </pageFooter>-->

<!--      <div class="languageSwitcher">-->
<!--        <span-->
<!--          class="langBtn fontSemiBold14"-->
<!--          :class="`langBtn&#45;&#45;${deBtnClass}`"-->
<!--          v-on:click="$emit('switchLanguage', 'de'), switchLanguage(true)"-->
<!--        >DE</span> |-->
<!--        <span-->
<!--          class="langBtn fontSemiBold14"-->
<!--          :class="`langBtn&#45;&#45;${enBtnClass}`"-->
<!--          v-on:click="$emit('switchLanguage', 'en'), switchLanguage(false)"-->
<!--        >EN</span>-->
<!--      </div>-->
<!--    </div>-->

    <div class="header-bottom">
      <div class="buddha"></div>
      <section class="section--header">
        <overlay></overlay>
        <div class="cite">
          <h2 :class="{mounted: isMounted}" class="cite__text">Wenn du ein Problem hast, versuche es zu lösen. Kannst du es nicht lösen, dann mache kein Problem daraus.</h2>
          <div class="fontLight12 cite__author">- Buddha -</div>
        </div>
      </section>
    </div>
  </header>
</template>

<script>
import overlay from './overlay.vue';

export default {
  name: 'pageHeader',
  components: {
    overlay,
  },
  data() {
    return {
      langIsGerman: true,
      lang: '',
      deBtnClass: 'active',
      enBtnClass: 'inActive',
      linkHome: '/',
      isMounted: false,
      isNavigationOpen: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isMounted = true;
    }, 1250);
  },
  methods: {
    switchLanguage(isGerman) {
      this.langIsGerman = isGerman;
      this.lang = isGerman === true ? '' : '/en';
      this.deBtnClass = isGerman === true ? 'active' : 'inActive';
      this.enBtnClass = isGerman === true ? 'inActive' : 'active';
      this.linkHome = isGerman === true ? '/' : '/en/home';

      const routeName = this.$route.path.split('/').pop();
      this.$router.push(`${this.lang}/${routeName}`);

      this.toggleNavigation(false);
    },
    toggleNavigation(openIt) {
      this.isNavigationOpen = typeof openIt === 'undefined' ? !this.isNavigationOpen : openIt;
    },
  },
};
</script>

<style lang="scss" scoped>
  .header-top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media #{$mobile} {
      padding: 0 var(--sectionPadding);
      height: 50px;
    }
    @media #{$min-tablet} {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      padding: 0 var(--sectionPaddingDesk);
      height: 75px;
      z-index: 1;
    }
    @media #{$desktop} {
      height: 100px;
    }
  }

  .logo__text {
    position: relative;
    width: 12rem;
    height: 1.6rem;
    color: transparent;
    @media #{$mobile} {
      background: url("../assets/img/exa-logo.svg") 0 0 / auto 100% no-repeat;
    }

    @media #{$min-tablet} {
      background: url("../assets/img/exa-logo-black.svg") 100% 0 / auto 100% no-repeat;
      margin-left: auto;
    }
  }
  .logo__top {
    top: 3px;
  }
  .logo__bottom {
    bottom: 4px;
  }
  .logo__subText {
    position: absolute;
    left: 4.5rem;
    font-size: 0.8rem;
    opacity: 0;
    transition: opacity 0.5s;
  }
  .logo__subText.active {
    opacity: 1;
  }

  .header-bottom {
    position: relative;
    background: linear-gradient(45deg, rgba(20,90,127,1) 0%, rgba(20,90,127,1) 0%, rgba(67,172,223,1) 100%);
  }
  .buddha {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("../assets/img/buddha-trans-mob.svg") 0 0 / auto 100% no-repeat;
  }


  .cite {
    text-align: center;

    @media #{$mobile} {
      padding: 7.5rem var(--boxPadding) 2rem;
    }
    @media #{$min-tablet} {
      padding: 7.5rem var(--boxPaddingDesk) 5rem;
    }
    @media #{$desktop} {
      padding: 13rem var(--boxPaddingDesk) 8rem;
    }
  }
  .cite__text {
    color: var(--white);
    transform: scale(0.9);
    transition: transform 15s;
    margin: 0 auto 1rem;

    @media #{$min-tablet} {
      width: 80%;
    }
    @media #{$desktop} {
      margin-bottom: 2rem;
    }
  }
  .cite__text.mounted {
    transform: scale(1);
  }
  .cite__author {
    color: var(--white);
    margin-bottom: 1rem;
  }

  .hamburger {
    cursor: pointer;
    width: 24px;
    height: 24px;

    @media #{$mobile} {
      background: url("../assets/img/hamburger-mobile.svg") center / 100% no-repeat;
    }
    @media #{$min-tablet} {
      background: url("../assets/img/hamburger.svg") center / 100% no-repeat;
    }
  }

  .hamburger.active {
    @media #{$min-tablet} {
      background: url("../assets/img/hamburger-mobile.svg") center / 100% no-repeat;
    }
  }

  .navigation {
    position: relative;
    max-height: 0;
    transform: scaleY(0);
    transition: all 0.5s;
  }

  .navigation.active {
    transform: scaleY(1);
    padding-top: 1rem;
    max-height: 300px;

    @media #{$min-tablet} {
      margin-top: 100px;
    }
  }

  .languageSwitcher {
    position: absolute;

    @media #{$mobile} {
      right: var(--sectionPadding);
      bottom: var(--sectionPadding);
    }
    @media #{$min-tablet} {
      right: var(--sectionPaddingDesk);
      bottom: var(--sectionPadding);
    }
  }

  .langBtn {
    text-decoration: none;
    padding: 0.5rem;
  }

  .langBtn--active {
    color: var(--red);
  }

  .langBtn--inActive {
    cursor: pointer;
  }
</style>
